import { z } from 'zod'
import {
  BasePaginateParamsSchema,
  BasePaginateResultSchema,
} from '@/api/common.ts'
import { QcHoldType } from '../qc8010/list.schema'

export enum QcHoldResultType {
  Hold,
  SortingOrRework,
  Rejected,
}

export const Qc8020SearchParamsSchema = z
  .object({
    number: z.string().optional(),
    itemId: z.number().optional(),
    dateFrom: z.coerce.date().optional(),
    dateTo: z.coerce.date().optional(),
    status: z
      .union([z.literal('1'), z.literal('2'), z.literal('3'), z.literal('4')])
      .optional(),
  })
  .merge(BasePaginateParamsSchema)

export type Qc8020SearchParams = z.infer<typeof Qc8020SearchParamsSchema>

export const Qc8020SearchResultModelSchema = z.object({
  id: z.string(),
  number: z.string(),
  date: z.coerce.date(),
  item: z.object({
    itemId: z.number(),
    lotNo: z.string(),
    lotDate: z.coerce.date(),
    mold: z.string(),
    unit: z.string(),
  }),
  sortingReworkResult: z.object({
    date: z.coerce.date().nullable(),
    qtyPassed: z.number(),
    qtyRejected: z.number(),
    remark: z.string(),
    byName: z.string(),
  }),
  isConfirmSortingResultSet: z.boolean(),
  isNeedSortingReworkResult: z.boolean(),
  qty: z.number(),
  qtySortingRework: z.number(),
  type: z.nativeEnum(QcHoldType),
  createdAt: z.coerce.date(),
  status: z.number(),
})

export type Qc8020SearchResultModel = z.infer<
  typeof Qc8020SearchResultModelSchema
>

export const Qc8020SearchResultSchema = z
  .object({
    items: z.array(Qc8020SearchResultModelSchema),
  })
  .merge(BasePaginateResultSchema)

export type Qc8020SearchResult = z.infer<typeof Qc8020SearchResultSchema>
